import React, { useEffect, useState } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Button, DatePicker } from 'antd';
import moment from 'moment';

const { RangePicker } = DatePicker;

interface Props {
    search: (min: string, max: string) => void;
    current?: [string, string];
}

const DateRange = (props: Props) => {
    const [search, setSearch] = useState<[string, string]>(props.current ?? ['', '']);

    useEffect(() => {
        setSearch(props.current ?? ['', '']);
    }, [props.current]);

    const reset = () => {
        setSearch(['', '']);
        props.search('', '');
    };

    return (
        <form
            onSubmit={e => {
                e.preventDefault();
                props.search(search[0], search[1]);
            }}
            style={{ padding: 8 }}
        >
            <div className={'date-picker'} style={{ marginBottom: '5px' }}>
                <RangePicker
                    value={search[0] && search[1] ? [moment(search[0]), moment(search[1])] : null}
                    onChange={(_, v) => {
                        setSearch(v as [string, string]);
                    }}
                />
            </div>
            <div style={{ zIndex: 0 }}>
                <Button
                    type="primary"
                    htmlType="submit"
                    icon={<SearchOutlined />}
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                >
                    Search
                </Button>
                <Button onClick={reset} size="small" style={{ width: 90 }}>
                    Reset
                </Button>
            </div>
        </form>
    );
};

export default DateRange;
